function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "uploadFile_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 720",
  transform: "translate(79 645)",
  fill: "#fff",
  stroke: "#707070",
  d: "M0 0h24v24H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Mask Group 81",
  transform: "translate(-79 -645)",
  clipPath: "url(#uploadFile_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 930",
  d: "M79 645h24v24H79z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 931",
  d: "M88 661h6v-6h4l-7-7-7 7h4zm-4 2h14v2H84z",
  fill: "#034ccb"
}));

function SvgUploadFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default SvgUploadFile;